import * as localStorageService from '../services/localStorageService';

export default (value) => {
  return localStorageService.setItem('dlt', value);
};
